import React from 'react';
import { stringify } from 'querystring';
import { connect } from 'react-redux';
import md5 from 'md5';
import loadable from '@loadable/component';
import links from '../gym/links.json';
import { fetch, getData } from '../index/move-blocks';

const Exercise = loadable(() => import('../exercise/Show'), { ssr: true });
const Exercises = loadable(() => import('../exercises/Start'), { ssr: true });
const Routine = loadable(() => import('../routine/Show'), { ssr: true });
const NotFound = loadable(() => import('../user/NotFound'), { ssr: true });
const Gym = loadable(() => import('../gym/Show'), { ssr: true });
const Home = loadable(() => import('../index/Start'), { ssr: true });
const Footer = loadable(() => import('./Footer'), { ssr: true });

const database = {
  movie: {},
  person: {},
  footer: {},
  movies: {},
  exercise: {},
  workout: {},
  gyms: {},
  exercises: [],
  places: {},
};

const getTypeId = (params, query) => {
  let {
    id, type,
  } = params;

  const {
    name, city, country, area, result, page,
  } = params;

  if (type === 'workout-center') {
    type = 'exercises';
    query.name = name;
  } else if (type === 'year') {
    type = 'movies';
    query.year = [id, id];
  } else if (type === 'footer') {
    if (country) {
      query.country = country;
    }
  } else if (!type) {
    type = 'places';
    if (city) {
      query.city = city;
    } else {
      delete query.city;
    }
    if (area) {
      query.area = area;
    } else {
      delete query.area;
    }
    if (country) {
      query.country = country;
    } else {
      delete query.country;
    }
    if (result) {
      query.result = result;
    } else {
      delete query.result;
    }
  } else {
    let matched = false;
    if (type === 'gyms' && !id) {
      type = 'places';
      matched = true;
    }
    links.forEach((elements, category) => {
      elements.forEach((item, element) => {
        if (type === item[0]) {
          query[`infos.${category}.${element}`] = 1;
          type = 'places';
          matched = true;
        }
      });
    });
    if (!matched) {
      query = '';
    }
  }
  if (type === 'places') {
    if (city) {
      query.city = city;
    } else {
      delete query.city;
    }
    if (area) {
      query.area = area;
    } else {
      delete query.area;
    }
    if (country) {
      query.country = country;
    } else {
      delete query.country;
    }
    id = md5(JSON.stringify(query));
  }
  if (query) {
    if (page) {
      query.offset = parseInt(page, 10) * 10;
    } else {
      delete query.offset;
    }
    id = md5(JSON.stringify(query));
    if (page !== undefined) {
      query.offset = page * query.limit;
    }
  }
  return { id, type, query };
};

class Load extends React.Component {
  constructor(props) {
    const { amp } = props;
    const params = { ...(props.match ? props.match.params : {}), ...props };
    const { id, type, query } = getTypeId(params, props.query);
    const jsonData = getData();

    const data = props.data || jsonData || (database[type] && database[type][id]);
    let source;

    if (props.data) {
      source = 'props';
    } else if (jsonData) {
      source = 'json';
    } else {
      source = (data ? 'database' : '');
    }
    const loaded = !!data;

    super(props);

    this.type = type;
    this.id = id;
    this.source = source;

    this.state = {
      amp,
      loaded,
      type,
      data,
      query,
      exists: true,
    };

    this.setCountry = props.setCountry.bind(this);
  }

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    const { props } = this;
    const params = { ...(props.match ? props.match.params : {}), ...props };
    const { id, type, query } = getTypeId(params, props.query.query);
    const loaded = id ? this.id === id : this.query === JSON.stringify(query);
    const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

    this.id = id;
    this.type = type;
    this.query = JSON.stringify(query);

    if (!loaded || this.source !== 'database') {
      if (indexedDB) {
        this.source = 'database';
        const request = indexedDB.open(type, 15);

        request.onerror = (error) => {
          console.warn(error);
        };
        request.onsuccess = (event) => {
          this.getfromDB(event.target.result, id, query);
        };
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          try {
            db.deleteObjectStore(type);
          } catch (e) {
          }
          const objectStore = db.createObjectStore(type, { keyPath: 'id' });
          objectStore.transaction.oncomplete = () => {
            this.getfromDB(db, id, query);
          };
        };
      }
    }
  }

  getfromDB(db, id, query) {
    const self = this;
    const { type } = self;
    const transaction = db.transaction([type], 'readwrite');
    const objectStore = transaction.objectStore(type);
    const source = 'database';

    this.db = db;
    this.source = source;
    id = id || '-';
    const request = objectStore.get(id);

    request.onerror = (e) => {
      console.log(e);
    };

    request.onsuccess = () => {
      // Do something with the request.result!
      let data = request.result;
      const loaded = !!(data && Object.keys(data).length);

      if (loaded) {
        if (data.country) {
          self.setCountry(data.country);
        }
        if (data.countryInfo) {
          self.setCountry(data.countryInfo.alias);
        }
      }
      this.setState((previous) => {
        if (previous.type === type) {
          data = data || previous.data;
        }

        const exists = !!(!loaded || (data && Object.keys(data).length));

        return {
          data,
          type,
          query,
          loaded,
          source,
          exists,
        };
      }, () => {
        let url = `/api/${type}`;
        if (query) {
          const newQuery = { ...query };
          let infos = '';
          if (query.infos) {
            Object.keys(query.infos).forEach((i) => {
              infos += `&infos${i}=1`;
            });
            delete newQuery.infos;
          }
          url += `?${stringify(newQuery)}${infos}`;
        } else {
          url += `/${id}`;
        }
        fetch(url, {
          method: 'get',
        }).catch((e) => {
          console.warn(e);
        }).then((response) => response.json()).catch((e) => { console.warn(e); })
          .then((httpData) => {
            if (httpData) {
              const loaded2 = true;
              const saveTransaction = db.transaction([type], 'readwrite');
              const saveObjectStore = saveTransaction.objectStore(type);
              data = httpData;
              const dbData = { id, ...data };
              saveObjectStore.put(dbData);
              database[type][id] = data;

              const exists = !!(!loaded2 || (data && Object.keys(data).length));

              if (id === this.id && type === this.type) {
                if (data.country) {
                  self.setCountry(data.country);
                }
                if (data.countryInfo) {
                  self.setCountry(data.countryInfo.alias);
                }
                this.setState({
                  data,
                  query,
                  loaded: loaded2,
                  exists,
                });
              }
            }
          });
      });
    };
  }

  render() {
    const { state } = this;
    const { data, query, amp } = state;
    let child = Home;
    if (this.type === 'footer') {
      child = Footer;
    }
    if (this.type === 'exercise') {
      child = Exercise;
    }
    if (this.type === 'workout') {
      child = Routine;
    }
    if (this.type === 'gyms') {
      child = Gym;
    }
    if (this.type === 'exercises') {
      child = Exercises;
    }
    if (this.type === 'places') {
      child = Home;
    }
    const props = {
      loaded: state.loaded,
      type: this.type,
    };
    if (data) {
      props.data = data;
    } else {
      props.data = {};
    }
    if (query) {
      props.data.query = query;
    }
    props.amp = amp;
    const props1 = this.props;
    if (props1.static) {
      props.static = 1;
    }
    if (props1.sitename) {
      props.sitename = props1.sitename;
    }
    const childrenWithExtraProp = React.createElement(child, props);
    if (state.exists) {
      return (childrenWithExtraProp);
    }
    return (
      <NotFound />
    );
  }
}

const mapStateToProps = (state) => ({
  query: state.query,
});

const mapDispatchToProps = (dispatch) => ({
  setQuery: (data) => {
    dispatch({
      type: 'SET_QUERY',
      query: data,
    });
  },
  setCountry: (data) => {
    dispatch({
      type: 'FOOTER_PARAMS_COUNTRY',
      country: [data],
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Load);
